import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const DELETE_ACCOUNT_NOTE = gql`
  mutation DeleteAccountNote($id: Int!) {
    deleteAccountNote(id: $id)
  }
`;

export function useDeleteAccountNote() {
  const [deleteAccountNoteMutation, { loading }] =
    useMutation(DELETE_ACCOUNT_NOTE);

  const deleteAccountNote = useCallback(
    async (id) => {
      try {
        await deleteAccountNoteMutation({
          variables: { id },
        });
        return { success: true };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [deleteAccountNoteMutation]
  );

  return { deleteAccountNote, loading };
}
